import { gql } from "@apollo/client";

export const REMOVE_STOCK = gql`
	mutation RemoveStock($id: String!, $count: Float) {
		removeStock(id: $id,count:$count) {
			_id
			count
		}
	}
`;

export const ADD_STOCK = gql`
	mutation AddStock($id: String!, $count: Float) {
		addStock(id: $id, count: $count) {
			_id
			count
		}
	}
`;
